import { RuleCheckItem, RuleCheckResult, Validation, ValidationType } from './types';
import { checkRule } from './ruleChecker';

export const validateRequired = (value: string) => {
  return value.length !== 0;
};

export const validatePattern = (value: string, pattern: RegExp) => {
  return pattern.test(value);
};

export const validate = (value, config: Validation, valueToCompare?: string): boolean | RuleCheckResult => {
  let result: boolean | RuleCheckResult = false;
  const rules = Object.keys(config);
  rules.map((currentRule) => {
    switch (currentRule) {
      case ValidationType.REQUIRED:
        result = validateRequired(value);
        break;
      case ValidationType.PATTERN:
        result = validatePattern(value, new RegExp(config[currentRule] as string));
        break;
      case ValidationType.MATCH:
        if (!valueToCompare) return result;
        result = value === valueToCompare;
        break;
      case ValidationType.RULES: {
        const expressionRules = config[currentRule] as RuleCheckItem[];
        for (const rule of expressionRules) {
          result = result && checkRule(rule, value);
          if (result !== true) {
            break;
          }
        }
        break;
      }
      default:
        break;
    }
  });
  return result;
};
